import { ApiCallResultStatus } from 'store/apiCallResultStatus';
import { AugmentedBreach } from 'store/identityMonitoring/breachSelectors';

export type OneTimeScanCodeVerificationApiVersion = 'v1' | 'v2';

export const telemetryEventNamePrefix = 'OTSv2';
export const pageName = telemetryEventNamePrefix;

export const baseTelemetryProps = {
  IsOTSV2: true,
};

/**
 * Fake breaches used for testing
 */
const genericBreachInfo = {
  breachId: 'breachId1',
  breachAlertId: 'breachAlertId1',
  isActionable: false,
  isMarkedDone: false,
  isBreachIrrelevant: false,
  isStateLoading: false,
  recommendations: [],
  breachRecommendations: [],
  foundDate: '2024-12-01T00:00:00Z',
  breachCompletionDate: undefined,
  changePasswordUrl: undefined,
  breachStateApiStatus: ApiCallResultStatus.DEFAULT,
  state: 'Incomplete',
  source: undefined,
  breachEntityGroups: [
    {
      groupType: 'Email',
      entityId: 'entityId0',
      entityType: 'EmailAddress',
      value: 'email-address',
      lastModifiedDate: undefined,
      entityState: 'New',
    },
    {
      groupType: 'Password',
      entityId: 'entityId1',
      entityType: 'Password',
      value: '*****',
      lastModifiedDate: undefined,
      entityState: 'New',
    },
    {
      groupType: 'Address',
      entityId: 'entityId2',
      entityType: 'Address',
      entityState: 'New',
      line1: 'Street',
      line2: 'Apt',
      city: 'New York',
      state: 'NY',
      countryOrRegion: 'US',
      zip: '10001',
      lastModifiedDate: undefined,
    },
  ],
};
export const testBreachesForOTSv2 = [
  // unknown breach (with tooltip)
  {
    ...genericBreachInfo,
    isKnownSite: false,
  },
  // known site (no tooltip)
  {
    ...genericBreachInfo,
    isKnownSite: true,
    site: 'Website',
  },
] as Partial<AugmentedBreach>[];
